import { render, staticRenderFns } from "./additionalStaffPopover.vue?vue&type=template&id=4b0918c2&scoped=true"
import script from "./additionalStaffPopover.vue?vue&type=script&lang=js"
export * from "./additionalStaffPopover.vue?vue&type=script&lang=js"
import style0 from "./additionalStaffPopover.vue?vue&type=style&index=0&id=4b0918c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0918c2",
  null
  
)

export default component.exports